const moduleName = 'hidden';

export function hidden () {
    const hiddenBlocks = Array.from(document.body.querySelectorAll('.js-hidden-text'));
    if(hiddenBlocks.length) {
        hiddenBlocks.forEach((block) => {
            const height = block.clientHeight;
            const hiddenHeight = block.dataset.height;
            const hidden = block.querySelector('.hidden-text');
            if(height > hiddenHeight) {
                block.classList.add('_init');
                hidden.style.height = `${hiddenHeight}px`;
                if(block.classList.contains('unfolding')) {
                    block.insertAdjacentHTML('beforeend', '<button class="open-hidden-btn js-open-hidden"><svg class="svg-icon" width="18" height="8"><use' +
                        ' xlink:href="#down"></use></svg><span>Развернуть</span></button>');
                    block.querySelector('.js-open-hidden').addEventListener('click', function (){
                        const caption = this.querySelector('span');
                        if(block.classList.contains('_opened')) {
                            block.classList.remove('_opened');
                            hidden.style.height = `${hiddenHeight}px`
                            caption.textContent = 'Развернуть';
                        } else {
                            block.classList.add('_opened');
                            hidden.style.height = `${height}px`;
                            caption.textContent = 'Свернуть';
                        }
                    });
                }

            }
        });
    }
}
